/* eslint-disable linebreak-style */
import React from 'react';

const dogeIcon = (fill: string, size: number, style?: React.CSSProperties) => (
    <svg
        aria-hidden="true"
        data-testid="test-icon"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        style={style}
    >
        <title>doge icon</title>
        <g
            id="Layer_2"
            data-name="Layer 2"
            transform="translate(-469.979 -469.979)"
        >
            <g
                id="Layer_1"
                data-name="Layer 1"
                transform="translate(470.073 470.073)"
            >
                <g
                    id="Layer_1-2"
                    data-name="Layer_1"
                    transform="translate(0 0)"
                >
                    <circle
                        id="Ellipse_1"
                        data-name="Ellipse 1"
                        cx="12"
                        cy="12"
                        r="12"
                        transform="translate(-0.095 -0.095)"
                        fill="#988430"
                    />
                    <circle
                        id="Ellipse_2"
                        data-name="Ellipse 2"
                        cx="11.608"
                        cy="11.608"
                        r="11.608"
                        transform="translate(0.285 0.285)"
                        fill="#7a6a2a"
                    />
                    <circle
                        id="Ellipse_3"
                        data-name="Ellipse 3"
                        cx="11.364"
                        cy="11.364"
                        r="11.364"
                        transform="translate(0.529 0.529)"
                        fill={fill || '#BA9F33'}
                    />
                    <path
                        id="Path_1"
                        data-name="Path 1"
                        d="M135.525,720.583c-.068-.062-.14-.124-.206-.186s-.134-.124-.2-.186l-.2-.192c-.033-.033-.068-.062-.1-.1l-.1-.091c-.268-.254-.537-.508-.8-.763.274.25.541.5.815.753l.1.1c.033.033.068.062.1.1l.2.186c.068.062.134.124.2.192s.134.13.2.192Zm-3.555-.038s.974.1,1.45.169c.44.062,1.818.274,1.818.274Zm0,0c.274.023.547.052.821.081.14.014.274.029.408.043l.206.023.2.029.815.13.407.068c.134.023.268.049.408.072-.134-.014-.274-.033-.408-.052l-.407-.058-.815-.12c-.068-.01-.134-.023-.2-.033l-.206-.024c-.134-.013-.274-.033-.408-.049-.274-.033-.547-.068-.821-.111Zm3.171.7s-1.04.264-1.391.365-1.391.413-1.391.413l2.783-.778Z"
                        transform="translate(-130.381 -709.971)"
                        fill="#cfb66c"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_2"
                        data-name="Path 2"
                        d="M165.7,888.8c-.231.068-.461.134-.695.2l-.695.186-.691.2-.345.1c-.114.033-.231.062-.349.1.114-.038.231-.078.345-.111l.345-.111c.231-.072.46-.14.691-.212s.466-.12.7-.177.458-.112.693-.165h0Zm-2.637,1.419c.114-.043,1.434-.658,1.741-.8.154-.072.6-.23.6-.23Z"
                        transform="translate(-160.945 -877.53)"
                        fill="#cfb66c"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_3"
                        data-name="Path 3"
                        d="M173.69,920.931c.1-.038.2-.085.293-.13l.287-.134.576-.277c.192-.091.378-.192.576-.278.1-.043.2-.078.3-.11l.153-.049c.052-.013.1-.029.154-.043-.192.091-.394.169-.586.258s-.388.173-.586.258l-.586.258c-.2.08-.389.165-.584.246h0Zm.128.537s1.2-.7,1.607-.926c.215-.12.912-.466.912-.466Z"
                        transform="translate(-171.568 -908.242)"
                        fill="#cfb66c"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_4"
                        data-name="Path 4"
                        d="M183.71,934.045c.2-.124.407-.25.613-.378l.307-.186.313-.182c.1-.062.206-.124.312-.182a1.129,1.129,0,0,1,.159-.082l.163-.082c.215-.1.431-.211.658-.3-.206.13-.417.241-.629.355-.1.058-.212.111-.316.169s-.206.12-.312.177-.206.12-.312.177l-.316.173-.638.345h0Zm2.509-1.238s-.743.57-.984.753-.949.695-.949.695Z"
                        transform="translate(-181.459 -920.819)"
                        fill="#cfb66c"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_5"
                        data-name="Path 5"
                        d="M683.94,695.246l-.38-.72.221-.9,1.578-.609-.672-1.378.332-1.391.623-1.246,1.925-.3,1.415-1.349,3.054.231.6,3.266-1.155,4.112-.658,2.129-2.666.1-1.238-.858-1.45-.606Z"
                        transform="translate(-674.915 -678.657)"
                        fill="#e2cc85"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_6"
                        data-name="Path 6"
                        d="M401.823,1087.44a2.25,2.25,0,0,1-1,.13c-.182-.244-1.457-.359-1.457-.359a.714.714,0,0,0-.441.068,4.891,4.891,0,0,1-.8.163c-.25.062-.5-.264-.691-.332a2.7,2.7,0,0,1-.446-.244l-.537-.052-1.079-.456-1.714-1.708-.466.729-.144.9.518,1.069,1.4,1.271,2.721.691,1.613-.475,2.02-.854.507-.543Z"
                        transform="translate(-388.121 -1070.875)"
                        fill="#f1d789"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_7"
                        data-name="Path 7"
                        d="M304.4,689.632l.345-1.046.412-.675,1.325-.111-.4,1.16-1.108,1.972.46,1.76-.815.407-.25-.384-.2-.881-.014-.99Z"
                        transform="translate(-300.369 -679.101)"
                        fill="#f4ecb4"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_8"
                        data-name="Path 8"
                        d="M310.817,853.143l-.254-.355a.583.583,0,0,1-.029-.316c.038-.149.033-.159.014-.215s-.182-.25-.173-.417-.014-.225.111-.359a.45.45,0,0,0,.091-.355l.169.1.038-.058a.173.173,0,0,1,.062.124c.014-.1-.043-.59.085-.7s.355.518.355.518l-.14-.912-.359-.935-.638-.854-.038-.941v-.081a3.167,3.167,0,0,0-.375.806c-.058.244.082.541.052.893s-.052.322.033.46.293.423.212.629c-.072.177-.316.052-.316.052a.531.531,0,0,1-.114.2.435.435,0,0,0-.1-.192c0,.033-.014.078-.014.078s-.043-.134-.085-.3c-.058-.225-.12-.522-.176-.681-.023.091-.081.369-.081.369l.033.427.159.586.154.384.149.47.13.315.1.24.091.542.44.466.235.1.171-.087h0Z"
                        transform="translate(-305.295 -836.649)"
                        fill="#f3e19d"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_9"
                        data-name="Path 9"
                        d="M299.51,716.843a3.688,3.688,0,0,0-.407,1.079,7.137,7.137,0,0,0-.115,1.851,7.667,7.667,0,0,0,.258,1.525,8.5,8.5,0,0,0,.551,1.294l.014-.029a2.045,2.045,0,0,1-.159-.4c-.052-.206-.072-.45-.12-.561a2.677,2.677,0,0,1-.149-.341,1.461,1.461,0,0,0-.14-.489.991.991,0,0,1-.111-.388c-.019-.245.01-.518-.014-.743a2.987,2.987,0,0,1-.033-.825c.039-.2.241-.753.365-1.2.082-.283.033-.522.182-.769a2.172,2.172,0,0,0,.274-.609c.038-.136-.4.6-.4.6h0Z"
                        transform="translate(-295.243 -707.166)"
                        fill="#f2e8b0"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_10"
                        data-name="Path 10"
                        d="M375.94,747.42a.634.634,0,0,0-.241.134,3.5,3.5,0,0,0-.215.287,2.256,2.256,0,0,0-.2.423c-.085.169-.274.423-.3.514s-.062.518-.111.72a.969.969,0,0,0,.048.45l.111-.023a.349.349,0,0,0,.111.241c.111.095.13-.322.13-.322l.413-1.4.623-.423.068-.342-.444-.264h0Z"
                        transform="translate(-370.173 -737.958)"
                        fill="#f5eec0"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_11"
                        data-name="Path 11"
                        d="M396.252,783.977a1.043,1.043,0,0,0-.437.124c-.058.043-.081.078-.144.13a.949.949,0,0,0-.287.307,2.037,2.037,0,0,0-.177.667c-.019.149-.019.287-.033.408a1.693,1.693,0,0,0-.033.384c.019.186.212.283.23.495l.4-.2.375-1.477.8-.5-.45-.5-.239.166h0Z"
                        transform="translate(-390.183 -773.883)"
                        fill="#e6db9d"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_12"
                        data-name="Path 12"
                        d="M318.17,1211.916l0-.044c.058-.5.068-.877.111-1.114a2.92,2.92,0,0,0,.1-.586,2.637,2.637,0,0,1-.01-.5c.029-.206.231-.45.225-.619a.524.524,0,0,0-.13-.3c-.058-.082-.1-.15-.1-.15s.4-.273.394-1.376a.106.106,0,0,1,.023.01l.2.557.134.163.514.959.662.642.978.658.613.667.062,1.779-.8,1.04-.131.238a11.4,11.4,0,0,1-2.835-2.017Z"
                        transform="translate(-314.199 -1191.877)"
                        fill="#e5cb7a"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_13"
                        data-name="Path 13"
                        d="M509.56,1308.558a.548.548,0,0,1,.2-.365.218.218,0,0,1,.043.13,1.155,1.155,0,0,1,.786-.528.808.808,0,0,0,.648-.475l1.108-1.007,1.267-1.167,1.541-.541.72-.177a.4.4,0,0,1-.014.169,3.507,3.507,0,0,0,.739-.186c.124-.048.241-.068.3,0a.666.666,0,0,1,.111.407c.149-.033.322-.177.461-.163.221.023.417.283.642.283.3,0,.431-.182.638-.326.124-.085.3-.192.4-.264.241-.177,2.787-.955,2.787-.955l.893.058.144.959-.077,2.506-.029.028-4.059,2.12-5.626.862a11.284,11.284,0,0,1-3.6-1.237l-.029-.128h0Z"
                        transform="translate(-503.141 -1286.817)"
                        fill="#d8c173"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_14"
                        data-name="Path 14"
                        d="M344.85,1571.657c.08-.167.152-.307.164-.357.01.1.028.322.065.557Q344.964,1571.758,344.85,1571.657Z"
                        transform="translate(-340.538 -1551.299)"
                        fill="#f1d789"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_15"
                        data-name="Path 15"
                        d="M666.051,1427.9l.728-.2.062.02s.033.019.033.085c.091-.052.169-.043.225-.078.029.062.058.268.186.293a.571.571,0,0,0,.423-.169,2.82,2.82,0,0,1,.431-.316,2.284,2.284,0,0,1,.12.258c.163-.13.446-.658.85-.648a1.531,1.531,0,0,1,.56-.677,1.219,1.219,0,0,1,.9-.25,1.541,1.541,0,0,1,.423-.378.39.39,0,0,0,.349.023c.169-.078.359-.378.609-.417a.587.587,0,0,1,.388.081,6.33,6.33,0,0,1,1.232-.964c-.019-.058-.058-.277.532-.763.033.029.01.111.033.115a1.372,1.372,0,0,0,.336-.2,2.723,2.723,0,0,1,.658-.394.921.921,0,0,1,.633.095.3.3,0,0,1,.091-.043,1.207,1.207,0,0,0,.177-.038,1.228,1.228,0,0,1,0,.423.94.94,0,0,0,.192.082.868.868,0,0,1-.225.342c.1.048.114.1.258.153a2.842,2.842,0,0,0-.2.307c-.043.091-.2.47-.264.613s-.169.407-.215.461a3.7,3.7,0,0,1-.345.388c.115-.043.586-.186.786-.241l-.651.965a11.386,11.386,0,0,1-9.321,1.079Z"
                        transform="translate(-657.629 -1405.187)"
                        fill="#e0cd81"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_16"
                        data-name="Path 16"
                        d="M470.152,703.25a.7.7,0,0,0-.2.023c-.033.023.169.072.231.1a.53.53,0,0,1,.231.215,9.856,9.856,0,0,0,1.213.557l.834-.043.288-.4-.547-.479.384-1.131-.508.081-1.223.729-.613.235-.087.115Z"
                        transform="translate(-464.035 -693.208)"
                        fill="#dfc57c"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_17"
                        data-name="Path 17"
                        d="M629.053,792.849a.131.131,0,0,0,.115.062.516.516,0,0,1,.4.13c.111.14.417.586.417.586l.734.264.047-.864-.8-.557-.912.336v.043h0Z"
                        transform="translate(-621.103 -782.432)"
                        fill="#e5cc7c"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_18"
                        data-name="Path 18"
                        d="M583.922,831.046a.8.8,0,0,0,.3-.052c.169-.062.446-.2.567-.144.169.072.134.3.316.5.11.124.312.12.427.254s.508.072.508.072l.149.806-.6.769-.2.955h-.811l-.741-.294-.365-.883.182-.893.259-1.089Z"
                        transform="translate(-576.115 -820.309)"
                        fill="#d2c281"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_19"
                        data-name="Path 19"
                        d="M738.961,760.166a.22.22,0,0,0,.062.01.161.161,0,0,0-.052.173c.019.111.081.25.029.336a.42.42,0,0,1,.091.159c.033.1.043.182.258.2a.453.453,0,0,0-.085.068,1.412,1.412,0,0,1,.225.25,1.853,1.853,0,0,0,.283-.067l.043.029.091-.038s-.085-.033-.023-.241c.058-.182.111-.173.115-.186a1.908,1.908,0,0,0,.043-.283,3.414,3.414,0,0,0,.052-.407l-.062-.677-.349-.211L739.4,759l-.268.5-.176.176-.014.437.021.049Z"
                        transform="translate(-729.587 -749.39)"
                        fill="#e2c270"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_20"
                        data-name="Path 20"
                        d="M806.28,517.1a2.357,2.357,0,0,1,.085.312.3.3,0,0,0,.014-.081s.048.268.058.378c.019,0,.038-.01.043.01a1.621,1.621,0,0,1,.038.355.967.967,0,0,1,.326-.326.57.57,0,0,1,.264-.1c.15,0,.258.1.437.1a3.32,3.32,0,0,0,1.108-.413,1.465,1.465,0,0,0,.522-.241,1.362,1.362,0,0,0,.274-.341c.134-.23.274-.431.413-.456a.872.872,0,0,1-.192.014s.043-.043.115-.1a.448.448,0,0,1,.283-.13c.221,0,.332.033.456.033a.62.62,0,0,0,.2-.033.781.781,0,0,0,.423.091c.293,0,.489.029.642.043s.667-.043.815-.038a.716.716,0,0,1,.278.068l-.476-1.382-1.708-1.493-1.017.72-1.564,1.564-1.514.561-.316.355v.541Z"
                        transform="translate(-796.066 -506.893)"
                        fill="#ccb360"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_21"
                        data-name="Path 21"
                        d="M1023.387,548.068s.043-.043.114-.1a.445.445,0,0,1,.283-.13c.221,0,.332.033.456.033a.62.62,0,0,0,.2-.033.783.783,0,0,0,.423.091c.293,0,.489.029.642.043s.667-.043.815-.038a.71.71,0,0,1,.277.068l-.215-.623-.25-.475-.714-.782-.864-.508s-.3-.081-.3-.081l-.776.469-.7,1.822-.014.384.456.216c.115-.192.241-.345.359-.365-.107.012-.188.012-.188.012h0Z"
                        transform="translate(-1009.776 -538.651)"
                        fill="#d5b457"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_22"
                        data-name="Path 22"
                        d="M858.417,733.28c-.068,0-.124-.01-.14-.058-.058-.163-.1-.186-.153-.186s-.115.1-.154.114-.085-.12-.085-.12l-.043-.019a2.6,2.6,0,0,0-.427.355,3.553,3.553,0,0,1-.6.576,6.416,6.416,0,0,1-.729.111.946.946,0,0,0-.345.169c-.023.025.068.052.082.078s-.15.013-.163.038a.629.629,0,0,0,.062.186.316.316,0,0,1,.134-.033c.149,0,.258.1.437.1a3.316,3.316,0,0,0,1.108-.413,1.465,1.465,0,0,0,.522-.241,1.373,1.373,0,0,0,.274-.341,2.424,2.424,0,0,1,.217-.31h0Z"
                        transform="translate(-844.816 -723.733)"
                        fill="#d2b257"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_23"
                        data-name="Path 23"
                        d="M382.068,1242.976a1.622,1.622,0,0,0-.394-.514c-.1-.1-.163-.192-.231-.254a3.1,3.1,0,0,0-.388-.293c-.264-.2-.551-.2-.772-.437a4.02,4.02,0,0,1-.658-1.17c-.177-.47-.225-.619-.225-.633s.049-.1.111-.091.062.134.078.163a.975.975,0,0,0,.1.134,1.275,1.275,0,0,1,.287.417,1.892,1.892,0,0,0-.068-.336s.342.215.633.44.413.3.5.446a6.913,6.913,0,0,0,.384.633,10.892,10.892,0,0,0,1.42.528l.63.469.313.685-.245.384-.47.1-.763-.342-.244-.331h0Z"
                        transform="translate(-374.646 -1223.826)"
                        fill="#d2b159"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_24"
                        data-name="Path 24"
                        d="M455.55,1277.062a1.779,1.779,0,0,0,.547.495,5.255,5.255,0,0,0,1.4.518,3.914,3.914,0,0,0,.821.124,11.819,11.819,0,0,0,1.741-.25,8.349,8.349,0,0,0,1.108-.153,5.7,5.7,0,0,0,1.242-.46c.3-.14.58-.245.805-.379a3.426,3.426,0,0,1,.815-.456.691.691,0,0,1-.332.423c.14,0,.332-.013.332-.013a6.183,6.183,0,0,0-.514.359c-.2.153-.47.413-.743.586-.177.111-.369.192-.495.258a2.223,2.223,0,0,0-.633.46.287.287,0,0,1,.078,0,1.51,1.51,0,0,0-.437.13.589.589,0,0,0-.221.019c-.091.029-.212.1-.336.13a.423.423,0,0,1-.235.029l.029.058s-.23,0-.307,0c.014,0,.01.01.01.01a.123.123,0,0,0-.038.014.4.4,0,0,1-.12.052c-.023,0-.043,0-.072.01.01.023.086.153.12.23-.029.019-.466.349-.466.349a.337.337,0,0,1,.033.068c.014.042.019.1.033.134.033.058.052.068.052.068s-.052.01-.144.033a2.5,2.5,0,0,1-.307.072,1.2,1.2,0,0,1-.124.01.339.339,0,0,1-.052.394c-.157.188-.206.216-.254.336a.514.514,0,0,0-.078-.049.326.326,0,0,1-.149-.1,1.251,1.251,0,0,1-.058.182,2.26,2.26,0,0,0-.134.355c-.052-.058-.149-.173-.283-.15s-.241.206-.264.258c0-.033-.023-.058-.029-.019a1.476,1.476,0,0,1-.489.85c0-.091,0-.293-.014-.359a.944.944,0,0,1-.365.215c-.274.12-.23.241-.23.241a.6.6,0,0,1,.124-.394c.149-.2.241-.3.241-.312a.087.087,0,0,0-.019-.043c-.019-.019-.058-.043-.058-.058a.39.39,0,0,0,.241-.349.62.62,0,0,0-.163-.388c-.01-.01.091-.082.078-.1s-.134-.1-.149-.154a.453.453,0,0,1,.019-.085.24.24,0,0,0,.019-.1.8.8,0,0,0-.078-.2,1.068,1.068,0,0,0,.111,0,.959.959,0,0,1-.091-.182,2.342,2.342,0,0,0-.058-.241c.033,0,.115.01.115,0,0-.029-.072-.078-.038-.115a.194.194,0,0,1,.11.078.444.444,0,0,0-.144-.231.353.353,0,0,1,.283.019.38.38,0,0,1,.154.163s.068.052.173.13a1.884,1.884,0,0,0,.518.326.536.536,0,0,0,.283.01.434.434,0,0,0,.12-.048.227.227,0,0,1,.043-.02.928.928,0,0,0-.072-.12c.033,0,.072,0,.072,0s.023-.052-.081-.153c.023-.023.052-.038.052-.078a.228.228,0,0,1-.1-.072c.019-.013.048-.058.081-.072-.029-.023-.1-.12-.134-.13a.6.6,0,0,0,.091-.043,1.115,1.115,0,0,1-.215-.078,1.293,1.293,0,0,0-.177-.124c-.049-.02-.134-.029-.169-.068a.528.528,0,0,0,.124,0c.029,0,.043,0,.052,0s0-.043.072-.052a.356.356,0,0,0,.1-.033.268.268,0,0,1-.154-.081.6.6,0,0,0-.2-.15c-.048-.01-.14.033-.2.029a.177.177,0,0,1-.111-.049,1.623,1.623,0,0,1-.83-.326,2.929,2.929,0,0,1-.71-.571.855.855,0,0,1-.134-.062c-.186-.1-.444-.3-.437-.563h0Z"
                        transform="translate(-449.822 -1260.271)"
                        fill="#c2a44d"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_25"
                        data-name="Path 25"
                        d="M1008.556,390.56a.252.252,0,0,1,.115.078.358.358,0,0,1-.058.514.331.331,0,0,0,.186.029.907.907,0,0,0-.244.427.163.163,0,0,0,.072.169.645.645,0,0,0-.13.384,1.547,1.547,0,0,1,.192-.182,5.088,5.088,0,0,1,.475-.326.274.274,0,0,0,.014.1s.25-.206.461-.114c.095.043.052.177.052.177a.222.222,0,0,1,.221.043,4.142,4.142,0,0,1,.286.418,3.077,3.077,0,0,1,.182.25,3.171,3.171,0,0,1,.264.557c0-.1.029-.258.316-.159a1.762,1.762,0,0,1,.887.729c.274.417.341.887.479,1.066a1.519,1.519,0,0,1,.293.58,5.082,5.082,0,0,0,.245,1.558c.081-.326.206-1.05.206-1.05l.068-.638.078-1.975-2.063-1.714-1.613-1.17-1.05.1.066.149h0Z"
                        transform="translate(-995.689 -385.417)"
                        fill="#caa13e"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_26"
                        data-name="Path 26"
                        d="M1107.832,237.008s-.029-.192-.514-.518-.863-.322-1.213-.6c-.268-.215-.547-.71-.729-.873a1.189,1.189,0,0,1-.206-.627l.6-.5.886-1.281.749-.825.359.5.5.586.277,1.176.1,1.721-.806,1.236Z"
                        transform="translate(-1091.132 -228.924)"
                        fill="#b59544"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_27"
                        data-name="Path 27"
                        d="M1309.423,518.066a2.182,2.182,0,0,0-.1-.772,14.264,14.264,0,0,0-.537-1.369c-.052-.293-.014-.316.043-.349a.859.859,0,0,0,.384-.576.547.547,0,0,1,.475-.437l.221-.163.336.84.293.759.091.58.068.495-.159,1.046-.786.71-.334-.764h0Z"
                        transform="translate(-1292.124 -507.919)"
                        fill="#c89d3a"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_28"
                        data-name="Path 28"
                        d="M502.89,1700.5v-.021a.158.158,0,0,0,.043-.038c.014-.019.023-.043.033-.049a.371.371,0,0,1,.159-.029,1.232,1.232,0,0,0,.245.058,1.6,1.6,0,0,1,.561-.062c.388.072.479.335.7.485a.446.446,0,0,0,.336.058h.052c.01,0,.081-.082.12-.078.078,0,.085.068.134.072a4.284,4.284,0,0,1,.446-.029.214.214,0,0,1,.087.355.857.857,0,0,0-.258.307,1.089,1.089,0,0,1,.085.072,11.287,11.287,0,0,1-2.748-1.1Z"
                        transform="translate(-496.556 -1678.699)"
                        fill="#ceb052"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_29"
                        data-name="Path 29"
                        d="M1310.68,694.048a6.672,6.672,0,0,0,.407-.6,20.861,20.861,0,0,0-.332-2.815l.877-2.874-.023-.935a8.6,8.6,0,0,1,.144-1.238c.12.215.495.475.576.613a7.143,7.143,0,0,0,.15-1.415,10.607,10.607,0,0,1,.244,1.223l.173.749.225.8.25.84.149.58.085.14.072.245.068.264.2.619.115.508.091.922a1.425,1.425,0,0,1,.043.215.908.908,0,0,1-.014.177,2.122,2.122,0,0,1,.019.375.526.526,0,0,1-.14.384,2.322,2.322,0,0,0-.2.768l-.215-.143a.584.584,0,0,0-.058-.375.378.378,0,0,0-.407-.186,1.231,1.231,0,0,0-.4.12,2.368,2.368,0,0,1-.388.342,2.333,2.333,0,0,1-.671.163,1.8,1.8,0,0,0-.551.287,3.08,3.08,0,0,1-.485.256h0Z"
                        transform="translate(-1294.013 -676.12)"
                        fill="#cca847"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_30"
                        data-name="Path 30"
                        d="M1310.68,1287.424l.037.022a11.4,11.4,0,0,0,3.633-2.693c-.011-.393-.026-.8-.041-.944-.033-.316-.01-.638-.019-.825s-.114-.945-.163-1.141a.5.5,0,0,0-.169-.293,2.336,2.336,0,0,0-.1.46c0,.092-.019.313-.019.369-.014,0-.019-.038-.019-.052-.019.049-.043.134-.052.144s.014-.082,0-.1-.038-.01-.033-.058a.543.543,0,0,1,.013-.085.893.893,0,0,0-.1.3c-.043.215-.043.221-.058.241s-.091.1-.1.13c0,.052.072.1.078.134,0,.048-.068.273-.091.384s-.013.326-.038.437-.038.159-.1.2c.048.01.095.023.095.023a.717.717,0,0,1-.1.532c-.062.085-.078.124-.143.2a.891.891,0,0,0-.241.413.7.7,0,0,1-.013-.1,4.533,4.533,0,0,0-.287.369c-.111.173-.264.163-.307.206a.2.2,0,0,0-.038.182c-.038.01-.11.023-.159.173a.364.364,0,0,1-.173.206.923.923,0,0,1-.258.082.313.313,0,0,1,.091.029,1.556,1.556,0,0,1-.312.221.652.652,0,0,0-.258.312.224.224,0,0,1-.186.144c.038.023.1.078.124.095a.432.432,0,0,0-.244.12c-.136.113-.182.146-.245.155h0Z"
                        transform="translate(-1294.013 -1265.256)"
                        fill="#c39d3c"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_31"
                        data-name="Path 31"
                        d="M1099.551,1777.89a1.092,1.092,0,0,1,.24-.127,5.106,5.106,0,0,1,.749-.182,2.744,2.744,0,0,1,.365-.12c0,.034-.007.066-.011.1a11.289,11.289,0,0,1-1.343.333Z"
                        transform="translate(-1085.584 -1754.822)"
                        fill="#d2ba6b"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_32"
                        data-name="Path 32"
                        d="M1194.544,805.051a2.392,2.392,0,0,1-.173.547c-.111.212-.23.5-.23.5a.923.923,0,0,1,.023-.2,5.506,5.506,0,0,0-.576.365,1.949,1.949,0,0,0-.283.293,5.845,5.845,0,0,0,.2-.619,12.476,12.476,0,0,0-1.131.994l-1.058.856a3.65,3.65,0,0,1-.376.176c-.182.078-.4.143-.557.206a.885.885,0,0,1,.206-.312,2.288,2.288,0,0,0,.45-.576.524.524,0,0,0,0-.388c-.052.014-.173.02-.254.043a.5.5,0,0,0-.169.11,3.959,3.959,0,0,1,.2-.691c-.1,0-.274.033-.274.033a2.462,2.462,0,0,1,.652-.685,2.118,2.118,0,0,0-.369.114c-.24.1-.5.25-.7.332a15.443,15.443,0,0,0,1.348-2.294,7.961,7.961,0,0,0,.734-1.847,8.412,8.412,0,0,0,.052-1.04,7.006,7.006,0,0,0,.029-.9,2.131,2.131,0,0,1,.586,1.512,5.788,5.788,0,0,1-.9,2.9c.115.033.413.072.72-.46a6.267,6.267,0,0,0,.413-.9.793.793,0,0,1,.01.149,4.063,4.063,0,0,0,.658-1.223,1.685,1.685,0,0,1-.029,1.089,1.078,1.078,0,0,1-.407.6.919.919,0,0,0,.283-.12c.029.072.023.153.072.182s.115.078.124.124a1.406,1.406,0,0,0,.159-.25,5.3,5.3,0,0,0,.038,1.166.4.4,0,0,0,.407-.293,1.2,1.2,0,0,0-.023.648.763.763,0,0,0,.151-.151h0Z"
                        transform="translate(-1174.995 -789.944)"
                        fill="#c0993a"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_33"
                        data-name="Path 33"
                        d="M859.817,350.753a1.144,1.144,0,0,1-.4.062c-.221,0-.159-.085-.5-.085-.531,0-2.389.307-2.715.3a7.149,7.149,0,0,0,.714.091l2.366.033.475-.038.177-.359Z"
                        transform="translate(-845.31 -346.343)"
                        fill="#a88f33"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_34"
                        data-name="Path 34"
                        d="M602.712,681.077a2.7,2.7,0,0,0-.431.408,3.006,3.006,0,0,1-.342.437.3.3,0,0,0,.1-.014s0,.038-.023.048a.136.136,0,0,1,.111.038.2.2,0,0,0-.068.278.3.3,0,0,0,.212.114s-.033.1.1.085a7.828,7.828,0,0,1,.782-.111.428.428,0,0,1,.349.241c.115.186.215.215.215.215a1.1,1.1,0,0,0,.052-.431,1.284,1.284,0,0,0,.091-.437l-.1-.743-.44-.557-.57.316-.043.11Z"
                        transform="translate(-594.339 -672.043)"
                        fill="#e3c571"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_35"
                        data-name="Path 35"
                        d="M704.64,478.2s.043.1.221.11a.1.1,0,0,0-.014.081l.01.081a.178.178,0,0,0,.052-.038c.01.043-.01.111,0,.159a.351.351,0,0,0,.029.085.164.164,0,0,1,.01-.019.759.759,0,0,0,.134.192.08.08,0,0,1,.01-.038.135.135,0,0,0,.023.068.07.07,0,0,1-.019-.014,2.212,2.212,0,0,0,.062.466.215.215,0,0,0,.023-.033c0-.01,0,.085-.014.154a.674.674,0,0,0,0,.163.507.507,0,0,1,.114-.068.414.414,0,0,0,.212-.254,1.681,1.681,0,0,0,.078-.277.388.388,0,0,1,.038.115c0,.049.1.023.1.023l.02-.212.115-.479.1-.3.5-.786.912-.7.8.182.671-.912-1.157-.695-1.094.115-.993,1.376-.8,1.248-.144.206h0Z"
                        transform="translate(-695.726 -469.28)"
                        fill="#d8b65b"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_36"
                        data-name="Path 36"
                        d="M794.816,404.413a1.264,1.264,0,0,0-.264.115c-.2.1-.332.134-.408.283a.732.732,0,0,0-.081.268,1.85,1.85,0,0,1,.212-.078c.081-.019.173-.014.163.019a.224.224,0,0,1-.038.062s.154,0,.149.072a.4.4,0,0,1-.058.2c-.029.038-.149.1-.163.14-.033.091.014.1,0,.169a1.166,1.166,0,0,1-.287.456,2.45,2.45,0,0,0-.307.417,2.654,2.654,0,0,1-.159-.365c-.038.019-.244.134-.244.134l-.477-1.663.01-.111a.3.3,0,0,0,.052-.149c-.072-.023-.081-.043-.177-.134a1.189,1.189,0,0,0-.332-.278.211.211,0,0,0-.169-.124c-.117-.023-.186-.043-.186-.043a.2.2,0,0,0,.091-.072,1.2,1.2,0,0,1-.287.029,1.2,1.2,0,0,0-.264,0c-.087.014-.192.052-.231-.081-.043-.033-.134,0-.212.111s-.1.206-.254.25a.52.52,0,0,1-.068.186,2.115,2.115,0,0,1-.2.25c-.144.169-.12.446-.349.658s.038-.586.038-.586l.369-.883,1.05-1.027,1.63-.111.159.844.8.274.5.766h0Z"
                        transform="translate(-780.17 -397.48)"
                        fill="#d3ae4d"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_37"
                        data-name="Path 37"
                        d="M1011.067,404.837l-.685-.988-.479-.369s-.342-.629-.365-.648a4.507,4.507,0,0,0-.547-.062l.038.1a.252.252,0,0,1,.115.078.358.358,0,0,1-.058.514.332.332,0,0,0,.186.029.906.906,0,0,0-.244.427.162.162,0,0,0,.072.169.646.646,0,0,0-.13.384,1.55,1.55,0,0,1,.192-.182,4.97,4.97,0,0,1,.475-.326.275.275,0,0,0,.014.1s.25-.206.46-.115c.095.043.052.177.052.177a.222.222,0,0,1,.221.043,4.114,4.114,0,0,1,.287.417c.029.043.1.124.182.25a3.172,3.172,0,0,1,.264.557c0-.078.019-.186.153-.186l-.2-.365Z"
                        transform="translate(-996.163 -397.717)"
                        fill="#caa13e"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_38"
                        data-name="Path 38"
                        d="M368.487,621.205a.668.668,0,0,1,0-.355,3.577,3.577,0,0,0,.149-.691,2.462,2.462,0,0,1,.25-.776l.623-.283.441.12.13.59-.557.307a.428.428,0,0,1-.186.235c-.157.1-.375.186-.427.293a.855.855,0,0,0-.068.206.292.292,0,0,0-.254.072.372.372,0,0,0-.1.283Z"
                        transform="translate(-363.852 -611.28)"
                        fill="#f4efc8"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_39"
                        data-name="Path 39"
                        d="M338.751,495.061a.284.284,0,0,0-.091.115,2.336,2.336,0,0,1-.134-.763c0-.332-.024-.414.053-.529s.378-.235.335-.441a.322.322,0,0,0-.441-.221c-.154.038-.268.365-.427.528-.12.124-.264.1-.3.173-.052.091,0,.182-.019.241a1.157,1.157,0,0,1-.14.25,2.506,2.506,0,0,0-.514.935,1.6,1.6,0,0,1,.052-.388l-.029-.048.192-.629.124-.518.278-.868.489-.887.476-.532.495.033.058.743.283,1.4.6.733-.955.643-.378.033h0Z"
                        transform="translate(-332.858 -485.292)"
                        fill="#ebcc73"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_40"
                        data-name="Path 40"
                        d="M461.708,703.333a.241.241,0,0,1-.111,0c-.029-.016-.058-.033-.048-.052s.062-.052.062-.068a.054.054,0,0,0-.049-.058.053.053,0,0,0-.058.023.218.218,0,0,0-.078-.038.528.528,0,0,1,.062,0,.607.607,0,0,0-.169-.049c.049-.029.144-.114.206-.114s.1-.01.091-.043a.2.2,0,0,0-.111-.1c.019-.023.033-.058-.014-.153a.184.184,0,0,1-.014-.182,1.218,1.218,0,0,1,.085-.114.311.311,0,0,1,.081-.1,1.022,1.022,0,0,1,.144-.062c.068-.023.124-.052.163-.023a.053.053,0,0,1,.023.068.35.35,0,0,1,.254.014,1.92,1.92,0,0,0,.413.095l.105.212-.695.6-.287.144-.058.01h0Z"
                        transform="translate(-455.518 -693.301)"
                        fill="#e5c66b"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_41"
                        data-name="Path 41"
                        d="M493.069,606.695a2.682,2.682,0,0,0-.264.2c.029,0,.078.023.058.052a3.121,3.121,0,0,0-.241.225,1.488,1.488,0,0,0-.186.274.984.984,0,0,1-.326.225c.159,0,.479-.2.6-.2a.118.118,0,0,0,.1.13.754.754,0,0,0,.528-.12c.264-.159.177-.278.287-.355.212-.14.3-.264.413-.342a.757.757,0,0,1,.177-.1s0-.058.038-.052a.052.052,0,0,1,.043.033,1.191,1.191,0,0,1,.461-.182.027.027,0,0,1-.014-.013s.019-.01.023-.019.014-.019.023-.01.023.081.043.111c.043-.019.124-.2.124-.2l.2-.561v-.512l-.154.029-1.151.489-.7.724-.082.173Z"
                        transform="translate(-485.914 -597.637)"
                        fill="#e6bd62"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_42"
                        data-name="Path 42"
                        d="M705.928,487.02a.651.651,0,0,0,.177-.072.8.8,0,0,1-.124.278,2.332,2.332,0,0,0-.186.322c-.082.159-.091.388-.169.489a.357.357,0,0,1,.111-.033.512.512,0,0,0-.111.14.663.663,0,0,1-.235.313,1.867,1.867,0,0,0-.522.365c-.2.211-.4.479-.5.576a1.442,1.442,0,0,0,.144-.394c.019-.12,0-.264.029-.423a1.385,1.385,0,0,1,.192-.551,9.435,9.435,0,0,0,.431-1.242l.586-.186.177.419h0Z"
                        transform="translate(-695.459 -480.475)"
                        fill="#b6933f"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_43"
                        data-name="Path 43"
                        d="M772.163,399a1.634,1.634,0,0,0-.225.479c-.048.225,0,.206-.033.316a.413.413,0,0,0,0,.206.73.73,0,0,1,.244-.241,2,2,0,0,0,.384-.258,1.417,1.417,0,0,1,.326-.355c-.072-.01-.173-.043-.192-.038a4.337,4.337,0,0,1,.5-.355,1.945,1.945,0,0,1,.551-.369,2.4,2.4,0,0,1-.264,0c.038-.081.173-.12.307-.254s-.085-.332-.085-.332l-1.023.619-.495.582Z"
                        transform="translate(-762.117 -392.811)"
                        fill="#c49937"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_44"
                        data-name="Path 44"
                        d="M576,156.485l.023-.186.293-.47.307-.825v-1.127l-.023-.652.048-.427.037-.136.039-.052.25.13.346.47.033.906-.336,1.43-.959,1.046Z"
                        transform="translate(-568.731 -150.757)"
                        fill="#dfc068"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_45"
                        data-name="Path 45"
                        d="M339.546,148.139s-.154,0-.186.642-.049.974-.072,1.29a6.934,6.934,0,0,1-.1.695,1.911,1.911,0,0,1-.13.6,1.369,1.369,0,0,1-.312.466,1.926,1.926,0,0,1-.586.326,3.024,3.024,0,0,0-.695.159,1.056,1.056,0,0,0-.287.182,3.665,3.665,0,0,0-.772,1.046,14.578,14.578,0,0,0-.691,2.6l.078-.13a1.233,1.233,0,0,1,.182-.475c.169-.3.12-.642.355-1.223a6.664,6.664,0,0,1,.345-.753,2.8,2.8,0,0,1,.759-.926,2.4,2.4,0,0,1,.926-.369l.522-.345s.091-.177.212-.378a2.45,2.45,0,0,0,.431-1.059,9.822,9.822,0,0,0-.091-1.531c.01-.4.014-.7.1-.772s.023-.045.023-.045h0Z"
                        transform="translate(-331.515 -146.339)"
                        fill="#a88f33"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_46"
                        data-name="Path 46"
                        d="M631.533,149.259a7.417,7.417,0,0,0,.336-1.069c.02-.1.058-.2.068-.283a2.561,2.561,0,0,0,0-.932,1.661,1.661,0,0,0-.332-.5c-.095-.14-.14-.192-.12-.221a.215.215,0,0,1,.169-.072.578.578,0,0,1,.413.192,2.5,2.5,0,0,1,.268.759l.125.773.316.974-1.242.379h0Z"
                        transform="translate(-623.502 -144.412)"
                        fill="#c99e3d"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_47"
                        data-name="Path 47"
                        d="M663.53,155.459a.2.2,0,0,1-.12,0,.173.173,0,0,1-.078.163,6.552,6.552,0,0,0-.844.033.648.648,0,0,1-.466-.532c-.078-.312.058-.743.014-1.027a6.291,6.291,0,0,0-.173-.629c-.01-.13-.019-.163-.019-.244a.45.45,0,0,0-.111-.023c-.01-.038.01-.072-.033-.14a.772.772,0,0,1,.369.206.692.692,0,0,1,.177.225,1.8,1.8,0,0,1,.365.431c.1.2.3.84.342.945a.7.7,0,0,0,.115.182c.113.14.277.371.464.409h0Z"
                        transform="translate(-653.335 -151.201)"
                        fill="#b58634"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_48"
                        data-name="Path 48"
                        d="M706.47,187.5a5.391,5.391,0,0,1,.316.59,2.677,2.677,0,0,0,.326.642c-.078-.225-.215-.667-.3-.825a1.892,1.892,0,0,0-.345-.407h0Z"
                        transform="translate(-697.532 -185.201)"
                        fill="#a88f33"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_49"
                        data-name="Path 49"
                        d="M449.829,436.89a2.834,2.834,0,0,0-.561.241c-.12.062-.235.114-.345.163a6.017,6.017,0,0,1-.84.316c.019.023.029.033.029.033a.244.244,0,0,0,.052.149c-.029.029-.417.293-.3,1.176.078-.029.169-.068.182-.068s.029.068.058.068a.389.389,0,0,0,.225-.169,1.31,1.31,0,0,0,.25.935c.058-.068.206-.293.206-.293l0-.072a1.944,1.944,0,0,1,.1-.479,1.275,1.275,0,0,1,.241-.4l.83-1.186-.124-.417h0Z"
                        transform="translate(-442.211 -431.401)"
                        fill="#e6c367"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_50"
                        data-name="Path 50"
                        d="M532.241,358.361a.459.459,0,0,1-.124.062.48.48,0,0,1,.082-.378,5.061,5.061,0,0,0,.508-.652,1.415,1.415,0,0,1,.495-.873c.466-.417.648-.561.648-.561l.753-.378.926.365-.46,1.8-.357.844-1.42-.268-1.05.037h0Z"
                        transform="translate(-525.399 -351.131)"
                        fill="#dcba5a"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_51"
                        data-name="Path 51"
                        d="M585,438.2l.177-.221v-.157a1,1,0,0,0,.407-.268c.211-.215.5-.629.763-.6s.283.561.293.71a4.094,4.094,0,0,0,.1.671c.058.182-.629.873-.629.873l-.467.355L585,438.2Z"
                        transform="translate(-577.616 -431.464)"
                        fill="#e9ce77"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_52"
                        data-name="Path 52"
                        d="M627.73,530.293s.144-.225.038-.274a1.657,1.657,0,0,1,.176-.287,1.451,1.451,0,0,1,.345-.45,1.5,1.5,0,0,0,.47-.58,1.531,1.531,0,0,0,.043-.332.63.63,0,0,0,.091.062.542.542,0,0,1,.215.522.857.857,0,0,1-.154.475,2.286,2.286,0,0,1-.206.182c-.091.062-.124.134-.278.14a.185.185,0,0,1,.052-.029.357.357,0,0,0-.245.058c-.085.078-.267.316-.358.388l-.192.124h0Z"
                        transform="translate(-619.799 -521.711)"
                        fill="#cdae50"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_53"
                        data-name="Path 53"
                        d="M685.7,342.875a2.336,2.336,0,0,0-.714-.14c-.408-.014-1,.01-1.587.014-.629,0-1.2-.215-1.991-.254-.13-.078-.46-.417-1.492.3.062,0,.749-.159.988.14a1.2,1.2,0,0,1,.14.922c-.062.268-.264.658-.345.931s-.062.417-.12.609-.186.287-.111.508c.1-.062.153-.062.322-.44s.134-.648.413-.968a6.3,6.3,0,0,1,.9-.873,3.363,3.363,0,0,1,2.988-.144c.347-.037.607-.608.607-.608h0Z"
                        transform="translate(-671.322 -338.066)"
                        fill="#d2a83e"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_54"
                        data-name="Path 54"
                        d="M588.21,350.125a.183.183,0,0,0-.01-.043.313.313,0,0,0-.052-.078,2.49,2.49,0,0,0-.514-.043c-.3.033-.576.408-.7.6a3.544,3.544,0,0,1-.46.642.064.064,0,0,0-.01-.043s.01.014-.01.033-.019.029-.01.038l.029.029a2.378,2.378,0,0,0,.642-.461,3.237,3.237,0,0,1,.84-.6,1.186,1.186,0,0,1,.258-.076h0Z"
                        transform="translate(-579.032 -345.581)"
                        fill="#c29637"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_55"
                        data-name="Path 55"
                        d="M1081.288,248.94s-.062.078-.14.163c-.173.182-.4.388-.59.6s-.388.359-.619.623-.5.557-.567.642a.632.632,0,0,0-.111.3l-.072-.048a.478.478,0,0,0,.058.085c.049.068.124.154.163.206a.623.623,0,0,1,.1.221c.023,0,.173.033.359-.274s.431-.642.431-.642l.388-.576.245-.489.307-.547.047-.26h0Z"
                        transform="translate(-1065.484 -245.855)"
                        fill="#ac8132"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_56"
                        data-name="Path 56"
                        d="M1225.423,218.3a2.945,2.945,0,0,0-.326.307c-.091.115-.307.417-.307.417l.078-.01.394-.349.153-.274.008-.091Z"
                        transform="translate(-1209.222 -215.607)"
                        fill="#a88f33"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_57"
                        data-name="Path 57"
                        d="M1268.581,1149.011a.4.4,0,0,1,.086-.254,1.846,1.846,0,0,0,.547-.759,4.97,4.97,0,0,0,.25-.642,2.816,2.816,0,0,1-.652.427c.058-.12.091-.206.12-.268-.033-.029-.173-.062-.186-.078.078-.078.12-.268.277-.394.2-.154.571-.417.857-.652a5.713,5.713,0,0,0,.922-.941.352.352,0,0,1,.052.1s-.283.369-.431.6a.574.574,0,0,0-.12.316l.268-.115s.077.287-.274.724c.153-.058.215-.023.3-.072a1.361,1.361,0,0,0-.528.557,2.4,2.4,0,0,1-.85.988,7.069,7.069,0,0,0-.642.458h0Z"
                        transform="translate(-1252.452 -1130.897)"
                        fill="#a67a2e"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_58"
                        data-name="Path 58"
                        d="M1128.772,295.8a2.144,2.144,0,0,0-.183.59c0,.062-.019.111-.019.182a2.242,2.242,0,0,1-.038.609.321.321,0,0,0-.049-.1c-.029.081-.081.336-.124.431a2.028,2.028,0,0,1-.058-.532c0-.254.01-.3.01-.355a1.539,1.539,0,0,1-.082.244c-.029-.052-.062-.12-.1-.177a1.088,1.088,0,0,1-.077.124c0-.023-.014-.085-.02-.173a2.452,2.452,0,0,1,0-.258,1.169,1.169,0,0,1,.264-.446,3.724,3.724,0,0,0,.479-.792c.062-.134.326-.691.326-.691h.2l-.293.667s-.177.365-.268.5-.283.518-.369.668c.062-.081.114-.124.177-.2a3.2,3.2,0,0,0,.227-.289h0Z"
                        transform="translate(-1113.695 -290.793)"
                        fill="#8c6228"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_59"
                        data-name="Path 59"
                        d="M1203.167,216.32a.841.841,0,0,1-.154.278c-.12.144-.379.336-.5.489a1.322,1.322,0,0,0-.241,1.04,1.744,1.744,0,0,1,.3-.547,4.2,4.2,0,0,0,.5-.714,1.2,1.2,0,0,0,.115-.378l.038-.048-.023-.111-.033-.008Z"
                        transform="translate(-1186.963 -213.652)"
                        fill="#cba94c"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_60"
                        data-name="Path 60"
                        d="M1395.139,513.446a2.112,2.112,0,0,1-.1-.4c-.023-.192.038-.23-.033-.45-.043-.134-.12-.115-.14-.134a1.131,1.131,0,0,1-.029-.332,1.253,1.253,0,0,0-.023-.316c-.029-.023-.049-.043-.091-.186a2.119,2.119,0,0,0-.095-.258c-.023-.043-.092-.081-.092-.124,0-.085.078-.13.078-.154,0-.048-.062-.01-.078-.023s.049-.163.023-.182c-.01-.01-.078.072-.095.049s-.043-.254-.078-.408-.068-.258-.072-.3-.268-.8-.332-.978a4.6,4.6,0,0,1-.13-.47,2.448,2.448,0,0,0-.043-.258c-.01.019,0,.115-.02.111s-.062-.336-.078-.388a2.709,2.709,0,0,1-.115-.359c-.019-.13-.062-.47-.091-.7s-.042-.326-.042-.384a2.393,2.393,0,0,0-.023-.423,3.95,3.95,0,0,0-.182-.714c-.13-.326-.475-1.16-.537-1.368,0-.052.068-.023.068-.023s.169.423.293.749a5,5,0,0,0,.264.642,2.408,2.408,0,0,1,.287.873c.081.524.111,1.007.159,1.329a3.427,3.427,0,0,0,.091.479c.052.177.134.359.24.638a4.214,4.214,0,0,1,.2.6c.043.215.043.378.068.485.023.091.058.274.14.537s.2.6.283.815a4.519,4.519,0,0,1,.254.965,9.293,9.293,0,0,1,.073,1.067h0Z"
                        transform="translate(-1375.004 -497.907)"
                        fill="#a88f33"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_61"
                        data-name="Path 61"
                        d="M1250.136,213.019l-.01.023a.041.041,0,0,1,.023.049,1.175,1.175,0,0,1-.01.159c-.01.068-.029.12-.033.163a.817.817,0,0,1-.115.456c-.038.072-.062.134-.081.177a.525.525,0,0,1-.1.169c.068-.038.313-.192.437-.169a.911.911,0,0,0-.3.268.669.669,0,0,0,.23,0,3.2,3.2,0,0,1,.667-.1c.231.014.14-.277.14-.277l-.267-.586-.5-.355-.08.019Z"
                        transform="translate(-1233.922 -210.375)"
                        fill="#be9c44"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_62"
                        data-name="Path 62"
                        d="M1276.8,193.446a1.8,1.8,0,0,1-.316-1,18,18,0,0,1-.072-1.919l-.182-.446a1.042,1.042,0,0,0-.134-.407c-.1-.111-.283-.3-.369-.388s-.182-.215-.24-.235a.665.665,0,0,1,.658-.326.7.7,0,0,1,.7.375,3.664,3.664,0,0,1,.374,1.369,4.691,4.691,0,0,1-.082,2.1,2.14,2.14,0,0,1-.342.875Z"
                        transform="translate(-1259.274 -186.412)"
                        fill="#a17c34"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_63"
                        data-name="Path 63"
                        d="M1316.61,588.264a.381.381,0,0,0,.215-.049.606.606,0,0,0,.532-.225.453.453,0,0,1-.043.355.806.806,0,0,1,.13-.081,1.223,1.223,0,0,1-.215.83.34.34,0,0,1,.25-.091.988.988,0,0,1-.085.623.253.253,0,0,1-.25.085.478.478,0,0,0,0-.081c0-.052-.023-.1-.01-.14a.692.692,0,0,1-.2-.14,1.257,1.257,0,0,1-.4-.633.249.249,0,0,1,.182-.274.216.216,0,0,1-.043-.053.294.294,0,0,0-.058-.128Z"
                        transform="translate(-1299.786 -580.568)"
                        fill="#8c6228"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_64"
                        data-name="Path 64"
                        d="M1201.212,296.156s-.01-.014-.062.048c.01-.062.019-.12.023-.177a.611.611,0,0,1,.1-.144c-.029.058-.049.111-.049.111a.782.782,0,0,1,.177-.215c.072-.058.163-.085.2-.14a.359.359,0,0,0,.043-.078,1.209,1.209,0,0,0,.241-.245c.019-.023.048-.048.068-.072s.111-.048.2-.1.2-.124.268-.154c.13-.058.268-.052.332-.144.048-.014.1-.159.091-.283a1.176,1.176,0,0,1,.567.759,2.752,2.752,0,0,1-.14,1.166,1.782,1.782,0,0,1-.173.58c-.12.159-.508.384-.6.495-.081.091-.326.322-.316.489.01.124.163.192.2.215s.033.052.095.038.085-.043.11-.043.029.01.043.01a.14.14,0,0,0,.029,0s-.01.177-.423.23c-.029,0-.058.014-.1.019a.237.237,0,0,0,.13-.1c-.058-.01-.225-.019-.268-.033a.511.511,0,0,1,.095-.114c.033-.029,0-.038-.033-.023a1.548,1.548,0,0,0-.144.111,1.407,1.407,0,0,1-.169.154.378.378,0,0,1,.072-.332c-.023,0-.068.072-.111.058a.614.614,0,0,1,.013-.212.965.965,0,0,1,.15-.241l.609-1.089.13-.825-1.4.271h0Z"
                        transform="translate(-1185.885 -290.901)"
                        fill="#92723a"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_65"
                        data-name="Path 65"
                        d="M1164.791,409.721s-.033.023.033.068a.746.746,0,0,1-.062.1c-.033.038-.068.062-.082.1a.528.528,0,0,0-.052.144.71.71,0,0,1-.091.336,1.434,1.434,0,0,0-.086.163,1.2,1.2,0,0,0-.1.192,2.04,2.04,0,0,0-.033.254l.058-.072a.543.543,0,0,1-.085.14c.023-.019.091-.068.206-.169a5.1,5.1,0,0,1,.71-.537,1.042,1.042,0,0,1-.231.043c.048-.049.485-.561.714-.609a.091.091,0,0,0,.019-.062l-.2-.019-.4.085-.058-.307-.266.161Z"
                        transform="translate(-1149.496 -404.42)"
                        fill="#b18e3e"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_66"
                        data-name="Path 66"
                        d="M1198.495,386.482a.538.538,0,0,0-.1.182.615.615,0,0,1-.1-.13.334.334,0,0,0-.44-.186.814.814,0,0,1,0-.182,1,1,0,0,0,.3-.268,1.24,1.24,0,0,0,.235-.378c.038-.029.1-.078.192-.134.124-.085.274-.2.3-.332a.793.793,0,0,1-.369.072c.072-.033.182-.068.169-.212.029-.019.052-.033.052-.033a.193.193,0,0,0-.068-.01c0-.014-.01-.033-.043-.023s-.038.01-.043.023a.206.206,0,0,0-.091.023,1.407,1.407,0,0,1-.159.114l.033-.058a.674.674,0,0,0-.163.038,3.4,3.4,0,0,0-.413.2c.014-.023.02-.038.029-.043s.033-.01.033-.014a.138.138,0,0,1,0-.052,1.788,1.788,0,0,1,.153-.264.514.514,0,0,0,.082-.221l.3-.149.834-.192.541.033-.068.375-.32.654-.274.6-.312.365-.287.21Z"
                        transform="translate(-1182.567 -379.434)"
                        fill="#543e26"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_67"
                        data-name="Path 67"
                        d="M1204.3,355.807a4.85,4.85,0,0,1-.417.466c.058-.124.417-.864.547-1.069-.029-.023-.068-.023.023-.384-.077.182-.1.277-.169.326a.12.12,0,0,1-.115.033.08.08,0,0,0,.01-.048s-.274-.033-.461-.033a2.75,2.75,0,0,0-.763.182,3.118,3.118,0,0,0-.312.111c-.058.048-.091.1-.12.114s-.134.048-.159.085-.062.081-.062.091-.01.023.02.014c.01,0,.081-.043.163-.091.11-.062.244-.134.341-.177a1.582,1.582,0,0,1,.489-.115,3.05,3.05,0,0,1,.44-.078,3.681,3.681,0,0,1,.413.01c-.023.019-.043.043-.033.124a.61.61,0,0,1-.038.1c-.058.159-.169.423-.23.557-.085.182-.182.336-.23.431a3.128,3.128,0,0,1-.258.479c-.1.134-.159.215-.192.245s-.268.2-.25.264a1.3,1.3,0,0,0,.508-.336,4.078,4.078,0,0,1,.388-.475,1.3,1.3,0,0,0,.345-.489,2.141,2.141,0,0,1,.122-.342h0Z"
                        transform="translate(-1187.018 -350.381)"
                        fill="#806031"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_68"
                        data-name="Path 68"
                        d="M776.522,664.775a.609.609,0,0,1-.14.264c-.095.086-.264.159-.283.3s.169.215.169.215a.747.747,0,0,0-.1.3,2.014,2.014,0,0,0,.01.287.129.129,0,0,0-.038.038.316.316,0,0,0,.1.2c.1.078.177.124.225.1a.435.435,0,0,1,.02.049s.072-.182.12-.342.091-.14.11-.359a2.1,2.1,0,0,1,.23-.6l.144-.322-.235-.182-.332.035Z"
                        transform="translate(-766.269 -656.336)"
                        fill="#b6903c"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_69"
                        data-name="Path 69"
                        d="M806.449,692.2a1.409,1.409,0,0,0-.134.159.466.466,0,0,1-.2.2c-.091.033-.149.033-.144.124s.091.13.14.177a.227.227,0,0,1,.072.221.222.222,0,0,0,.13-.134c.049-.1.388-.743.388-.743h-.25Z"
                        transform="translate(-795.759 -683.445)"
                        fill="#685026"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_70"
                        data-name="Path 70"
                        d="M804.634,539.643a.191.191,0,0,0,0-.134c-.029-.058-.206-.078-.293-.144a.347.347,0,0,0-.293-.085c.014-.033.068-.1.023-.12a.526.526,0,0,0-.244.091c-.043.033-.14.072-.159.1s-.052.068-.072.048-.029-.048-.062-.029a.792.792,0,0,0-.221.225,1.15,1.15,0,0,1-.293.437c-.2.192-.283.316-.225.388s.086.019.1.081a.526.526,0,0,1-.01.182c-.023.1-.062.2-.01.215.134.043.264-.038.293-.014.058.052-.033.241.1.277a.428.428,0,0,0,.278-.033l.508-.274.489-.258.25-.495-.134-.413-.026-.043Z"
                        transform="translate(-792.607 -532.361)"
                        fill="#d4b968"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_71"
                        data-name="Path 71"
                        d="M907.968,552.9a.2.2,0,0,1,.02-.245c.1-.115.254-.163.312-.235a.089.089,0,0,0-.043-.029.386.386,0,0,1,.169-.159.162.162,0,0,0-.111-.052c-.1,0-.153.058-.241.058s-.1-.043-.1-.043.144-.013.13-.078-.038-.068-.038-.068a1.456,1.456,0,0,0,.326-.177.355.355,0,0,0,.052-.163c.033,0,.225-.1.3-.058s.023.159.023.159a1.913,1.913,0,0,0,.355-.35c.1.01.153-.072.23-.072.1,0,.245.13.274.407a1.743,1.743,0,0,1,.02.532,2.454,2.454,0,0,0,.038.667c.033.134.11.12.11.12a.218.218,0,0,1-.068.1.324.324,0,0,0-.052.225.923.923,0,0,0,.029.1.484.484,0,0,0-.078.12.136.136,0,0,1-.124.081.592.592,0,0,0-.085,0c-.062,0-.082.013-.12,0s-.068-.029-.052-.154-.479-.413-.479-.413l-.806-.287h0Z"
                        transform="translate(-896.42 -544.436)"
                        fill="#cca849"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_72"
                        data-name="Path 72"
                        d="M838.091,706.621s.177.235.9.235a1.827,1.827,0,0,0,.537-.052,1.466,1.466,0,0,0,.662-.479c.264-.312.206-.44.206-.44l-.153-.023-.5.068-1.476.629-.179.064Z"
                        transform="translate(-827.469 -696.93)"
                        fill="#585136"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_73"
                        data-name="Path 73"
                        d="M831.939,671.169s-.629.14-.629-.258a1.383,1.383,0,0,1,.485-.867,1.812,1.812,0,0,1,.342-.154h.58l.11.293-.048.633-.84.353Z"
                        transform="translate(-820.775 -661.42)"
                        fill="#252211"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_74"
                        data-name="Path 74"
                        d="M856.136,676.111s-.12-.111-.394.038a.985.985,0,0,0-.509.743c-.014.25.206.437.547.446a1.743,1.743,0,0,0,.485-.038l-.12-.149-.01-1.04h0Z"
                        transform="translate(-844.393 -667.522)"
                        fill="#c3b378"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_75"
                        data-name="Path 75"
                        d="M865,683.551s-.029-.023-.115.023a1.887,1.887,0,0,0-.258.212,1.055,1.055,0,0,0-.115.1c-.12.144-.221.378-.163.495s.25.25.739.159l-.09-.984h0Z"
                        transform="translate(-853.373 -674.901)"
                        fill="#e6d89c"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_76"
                        data-name="Path 76"
                        d="M869.232,659.548a.618.618,0,0,0-.078.312.515.515,0,0,0,.518.532c.312.019.522-.45.749-.633a.544.544,0,0,1,.277-.144,2.579,2.579,0,0,0-.648-.44.955.955,0,0,0-1.271.1c.134-.01.567-.12.567-.12l.211.068-.326.324h0Z"
                        transform="translate(-857.766 -650.657)"
                        fill="#252211"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_77"
                        data-name="Path 77"
                        d="M943.761,694.387c-.013-.029-.023-.068.033-.078s.081,0,.1.038.038.078.01.1a.135.135,0,0,1-.144-.056Zm-.091-.274s-.019.014-.01-.014.029-.091.091-.078.049.082.038.1a.1.1,0,0,1-.1.038.032.032,0,0,1-.019-.048Z"
                        transform="translate(-931.685 -685.242)"
                        fill="#6f674d"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_78"
                        data-name="Path 78"
                        d="M534,662.627a.6.6,0,0,0,.332.111.9.9,0,0,0,.508-.3c.062-.068.115-.14.173-.2a1.035,1.035,0,0,0,.1-.1c.033-.038.068-.111.085-.134a1.783,1.783,0,0,1-.169.13,2.009,2.009,0,0,1-.25.13c-.052.019-.6.307-.6.307l-.188.06Z"
                        transform="translate(-527.268 -653.631)"
                        fill="#ac924c"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_79"
                        data-name="Path 79"
                        d="M552.34,586.323a.782.782,0,0,1,.25-.1,4.679,4.679,0,0,1,.479-.068l.264.115.1.4-.192.413-.244.154-.278-.446-.384-.47h0Z"
                        transform="translate(-545.374 -578.761)"
                        fill="#9f8e57"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_80"
                        data-name="Path 80"
                        d="M518.291,531.448l-.091.068a.59.59,0,0,0,.043-.173,1.6,1.6,0,0,1,.268-.629,2.03,2.03,0,0,1,.144-.173.1.1,0,0,0-.078.019.928.928,0,0,1,.268-.273c.124-.077.173-.1.3-.038s.163.1.258.091a.291.291,0,0,0,.177-.1s.019.062-.052.206a2.9,2.9,0,0,1-.355.437l-.59.4-.293.166h0Z"
                        transform="translate(-511.671 -523.531)"
                        fill="#eac970"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_81"
                        data-name="Path 81"
                        d="M559.421,532.376s.427.058.557-.062c0,.014.02.014.02.023a.034.034,0,0,1-.01.019l.043,0a.254.254,0,0,0,.052.01.3.3,0,0,0,.043,0,.073.073,0,0,1-.029.049c.019,0,.038,0,.038.019s0,.062-.019.072a.088.088,0,0,1-.058,0,.239.239,0,0,0,.029.1.219.219,0,0,0,.23.13s.058.14-.186.45c-.033.043-.068.1-.11.149a.56.56,0,0,0-.038.114.97.97,0,0,0,.532-.522,2.74,2.74,0,0,0,.12-1.059.547.547,0,0,0-.043-.212.183.183,0,0,0-.287-.033,3.51,3.51,0,0,1-.476.495,1.62,1.62,0,0,1-.408.264h0Z"
                        transform="translate(-552.363 -524.863)"
                        fill="#d7bc6b"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_82"
                        data-name="Path 82"
                        d="M508.9,634.125a.359.359,0,0,0-.124.23.753.753,0,0,0,.085.485.489.489,0,0,0,.375.277.408.408,0,0,0,.159-.033,1.006,1.006,0,0,0,.215-.134c.1-.072.173-.134.163-.14s-.586-.475-.586-.475l-.212-.236-.076.026Z"
                        transform="translate(-502.36 -626.088)"
                        fill="#585136"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_83"
                        data-name="Path 83"
                        d="M544.375,653.477a.49.49,0,0,0,.182-.052c.068-.043-.4-.5-.4-.5l.033.5Z"
                        transform="translate(-537.299 -644.667)"
                        fill="#453a25"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_84"
                        data-name="Path 84"
                        d="M517.66,613.26a.671.671,0,0,0-.058.14,2.451,2.451,0,0,0,.043.489.354.354,0,0,0,.313.254.443.443,0,0,0,.241-.078c0-.019-.144-.038-.182-.111a.653.653,0,0,1-.038-.23c0-.062,0-.13.019-.154a.5.5,0,0,0,.062-.225l.186-.346H518l-.293.182Z"
                        transform="translate(-511.078 -605.258)"
                        fill="#84754b"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_85"
                        data-name="Path 85"
                        d="M516.69,596.584a1.062,1.062,0,0,1,.365-.312.374.374,0,0,1,.25-.023l-.1.258-.144.159.01.081a.5.5,0,0,0,.12.365.376.376,0,0,0,.312.144.407.407,0,0,0,.332-.268.753.753,0,0,0-.014-.72.586.586,0,0,0-.495-.268.692.692,0,0,0-.636.584h0Z"
                        transform="translate(-510.18 -588.475)"
                        fill="#252211"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_86"
                        data-name="Path 86"
                        d="M899.493,675.169c-.072-.033,0-.235.068-.3a.506.506,0,0,1,.322-.144c.058,0,.114.033.1.072a.576.576,0,0,1-.206.245C899.656,675.144,899.575,675.206,899.493,675.169Z"
                        transform="translate(-888.056 -666.197)"
                        fill="#f7f7e7"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_87"
                        data-name="Path 87"
                        d="M588.864,623.161a.139.139,0,0,1,.134.1c.014.062-.033.186-.134.186-.081,0-.124-.1-.124-.13a.148.148,0,0,1,.019-.068A.111.111,0,0,1,588.864,623.161Z"
                        transform="translate(-581.308 -615.289)"
                        fill="#f8f6de"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_88"
                        data-name="Path 88"
                        d="M520.538,626.67a.451.451,0,0,0-.2.192.509.509,0,0,0-.038.307.753.753,0,0,0,.091.211.146.146,0,0,0,.111.068.2.2,0,0,0,.1-.144,1.023,1.023,0,0,1,.068-.394c.056-.12-.136-.241-.136-.241h0Z"
                        transform="translate(-513.739 -618.753)"
                        fill="#d4c38b"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_89"
                        data-name="Path 89"
                        d="M536.647,614.219c-.023.014-.062.033-.052.058s.091.038.12.1a.2.2,0,0,1,.023.149.235.235,0,0,0,.068-.049c.043-.048.095-.114.14-.114.029,0,.058.014.085.014.043,0,.085-.014.091-.058s-.081-.111-.134-.1a.127.127,0,0,0-.019-.134c-.043-.039-.177.029-.206.049s-.116.091-.116.091h0Z"
                        transform="translate(-529.828 -606.312)"
                        fill="#e2d59d"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_90"
                        data-name="Path 90"
                        d="M683.919,938.085l.287-.085.081.058s.058.124.149.14c-.029.062-.1.115-.1.159a.135.135,0,0,0,.043.078.668.668,0,0,0,.25.857c-.12.048-.274.115-.355.153a.63.63,0,0,1,.235.086c.052.047.052.062.1.091s.078.068.068.085c-.033-.019-.144-.078-.163-.023s-.479.033-.479.033l-.776.149a.14.14,0,0,0-.052-.149c-.095-.085-.211,0-.336-.091-.163-.124-.169-.268-.221-.322a1.027,1.027,0,0,1,.413-.115.171.171,0,0,1-.023-.13c.023-.068.12-.111.091-.192.043-.01.062-.01.169-.144s.163-.163.241-.173a.354.354,0,0,0,.268-.134c.1-.1.068-.177.068-.177s.066-.021.043-.155h0Z"
                        transform="translate(-674.017 -926.101)"
                        fill="#cbac5a"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_91"
                        data-name="Path 91"
                        d="M715.084,940.552c0-.019.019-.029.124-.019s.768-.062.949-.072a5.95,5.95,0,0,1,1.137.062c.313.066.629.144.782.182s.2.058.2.078a.056.056,0,0,1-.058.033c-.019,0-.528-.159-.685-.192a6.2,6.2,0,0,0-1-.115,5.218,5.218,0,0,0-.623.023,5.014,5.014,0,0,1-.739.053c-.115-.014-.091-.014-.086-.033h0Z"
                        transform="translate(-706.029 -928.524)"
                        fill="#d6bc6f"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_92"
                        data-name="Path 92"
                        d="M453.113,1064.363a1.579,1.579,0,0,1,.542.479.208.208,0,0,1-.062.293s.225,0,.2.124a1.874,1.874,0,0,1-.638.4,1.034,1.034,0,0,1-.369.124c-.12.019-.45-.038-.518.058a.189.189,0,0,0-.019.212,1.111,1.111,0,0,0,.177.033s-.033.091-.359.1-.408.033-.427.068.062.014.212.038.359.038.359.038a.66.66,0,0,1-.244.1,4.08,4.08,0,0,0-.613.159.568.568,0,0,0,.154.085.957.957,0,0,0-.215.078c.029.019.068.043.068.043a1.338,1.338,0,0,1-.258.245,2.109,2.109,0,0,1-.831.254c-.47-.124-.528-.639-.642-.677-.173-.058-.254.058-.408-.023a.969.969,0,0,1,.177-.11c-.078-.038-.479-.293-.479-.293a2.983,2.983,0,0,0-.14-.268c-.078-.134-.192-.312-.278-.47a3.831,3.831,0,0,0-.365-.7c.029-.038.13-.033.13-.033l1.415.466,2.509.073.652-.931.277.033Z"
                        transform="translate(-442.497 -1050.815)"
                        fill="#dfc677"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_93"
                        data-name="Path 93"
                        d="M547.18,1120.889a.218.218,0,0,0,.052.043.758.758,0,0,1,.169.13c.019-.029.068-.082.154,0s.192.023.258.043.072.033.072.033a.492.492,0,0,1,.124-.068c.052-.019.115-.033.182-.052a1.025,1.025,0,0,1,.177-.033c.043.029.2.192.811-.048.58-.225.714-.25.811-.215.01-.023.019-.068.169-.062a1.157,1.157,0,0,0-.124-.274l-.685-.235h-.375l-1.123.206-.623.355-.048.179Z"
                        transform="translate(-540.28 -1105.921)"
                        fill="#c4a859"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_94"
                        data-name="Path 94"
                        d="M517.9,1077.078a.363.363,0,0,0,.169.215.971.971,0,0,1,.2.176s.029-.038.052-.077.043-.091.082-.1c.078-.033.254.029.293.019s.023-.078.058-.078c.081,0,.134.052.163.052s.1,0,.111-.019.013-.177.124-.254a.331.331,0,0,1,.307-.029c0,.029,0,.1.082.1a.4.4,0,0,1,.153.014c.068.023.149,0,.186.111.033-.01.111-.019.091-.13a.566.566,0,0,0,.153-.163c.02-.029.052-.062.078-.1a.316.316,0,0,1,.258.081c-.033.023-.053.038-.062.062a.686.686,0,0,1,.078.091c.029.038.049.085.085.1a3.241,3.241,0,0,0,.365,0,.732.732,0,0,1,.316.095c.019-.01.019-.014.068,0s.085.014.033-.048c.029.014.062.043.091.014a.191.191,0,0,1,.134-.082c.082-.01.111,0,.144-.081.043-.1-.1-.1-.1-.1s.068-.062.144-.144a.655.655,0,0,0,.221-.332.234.234,0,0,0-.2-.283l-1.186.365-1.45-.072-1.236.615h0Z"
                        transform="translate(-511.374 -1062.503)"
                        fill="#927d49"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_95"
                        data-name="Path 95"
                        d="M412.719,849.278a.417.417,0,0,0-.062.163c-.024.115-.014.1-.033.182a3.4,3.4,0,0,0-.169,1.166c.09.274.245.375.342.6a.86.86,0,0,1,.048.12c.033.144,0,.254.043.4a.44.44,0,0,0,.1.163c.115.12.3.235.384.316.114.12.277.365.485.388a.7.7,0,0,0,.4-.111,3.343,3.343,0,0,1,.307-.23,1.156,1.156,0,0,1,.258-.078,1.17,1.17,0,0,1,.413-.019,3.983,3.983,0,0,0,.652.13,1.775,1.775,0,0,0,.423-.058c.277-.082.613-.221.834-.283.13-.038.235-.048.341-.072a.735.735,0,0,0,.423-.212c-.058-.068-.13-.173-.518-.169a6.851,6.851,0,0,0-1.2.293,1.008,1.008,0,0,1-.638-.029c-.274-.1-.283-.169-.283-.169a1.227,1.227,0,0,1-.408-.714,1.278,1.278,0,0,1,.313-1.242.205.205,0,0,0,.062-.173.782.782,0,0,0,.149-.537c-.062-.258-.46-.206-.46-.206l-2.206.386h0Z"
                        transform="translate(-407.259 -838.128)"
                        fill="#6e6342"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_96"
                        data-name="Path 96"
                        d="M458.743,946.91a.2.2,0,0,0-.023.1c0,.052.019.12.177.274a.335.335,0,0,1,.1.283.489.489,0,0,0,.25-.072c.144-.068.192.052.192.052a.405.405,0,0,1,.134-.043.3.3,0,0,0,.12-.038,1.734,1.734,0,0,0,.316.254c.134.072.212.12.278.072a.184.184,0,0,0,.058-.169.5.5,0,0,0-.058-.1c-.043-.062-.111-.134-.115-.192-.01-.134.1-.293.077-.332s-.11-.049-.326.029a4.851,4.851,0,0,1-1.186-.122h0Z"
                        transform="translate(-452.951 -934.897)"
                        fill="#39331f"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_97"
                        data-name="Path 97"
                        d="M494.126,967.388s-.11-.1-.072-.613a.639.639,0,0,1,.14.014A1.1,1.1,0,0,1,494.126,967.388Z"
                        transform="translate(-487.825 -954.507)"
                        fill="#292311"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_98"
                        data-name="Path 98"
                        d="M432.2,810.084a.311.311,0,0,0,.043-.038.963.963,0,0,0-.072.811,1.075,1.075,0,0,0,.949.8,1.087,1.087,0,0,0,.945-.528c.1-.13.225-.293.332-.4.159-.173.283-.221.283-.388,0-.342-.349-.495-.864-.648a1.961,1.961,0,0,0-1.219-.029.667.667,0,0,0-.4.423h0Z"
                        transform="translate(-426.689 -799.323)"
                        fill="#252211"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_99"
                        data-name="Path 99"
                        d="M567.78,1013.663l.038-.019s.01-.154.072-.149a.12.12,0,0,1,.085.12.072.072,0,0,1-.082.072.191.191,0,0,1-.114-.023Z"
                        transform="translate(-560.616 -1000.629)"
                        fill="#3f3824"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_100"
                        data-name="Path 100"
                        d="M554.31,975.588s.038-.014.085.033a.7.7,0,0,1,.258.014.2.2,0,0,1,.068.062.673.673,0,0,1-.3,0C554.31,975.66,554.31,975.588,554.31,975.588Z"
                        transform="translate(-547.319 -963.206)"
                        fill="#2d2815"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_101"
                        data-name="Path 101"
                        d="M596.227,968.108a.481.481,0,0,0-.215-.1c-.019,0-.023.01-.038.01s-.014-.033-.014-.033l-.063.033s-.01.014.023.038.078.043.091.081a.334.334,0,0,0,.019.058.207.207,0,0,0,.1-.019c.033-.019.1-.051.091-.064h0Z"
                        transform="translate(-588.372 -955.697)"
                        fill="#82764f"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_102"
                        data-name="Path 102"
                        d="M545.21,997.98a.163.163,0,0,1,.149-.14.15.15,0,0,1,.159.12l-.078.078s-.058-.083-.23-.058Z"
                        transform="translate(-538.335 -985.174)"
                        fill="#2d2816"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_103"
                        data-name="Path 103"
                        d="M591.654,956.9a.406.406,0,0,1-.231.1.092.092,0,0,1,0-.12c.043-.062.091-.082.14-.062A.113.113,0,0,1,591.654,956.9Z"
                        transform="translate(-583.935 -944.67)"
                        fill="#574f35"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_104"
                        data-name="Path 104"
                        d="M631.563,952.759c0-.019-.01-.023,0-.033s.062-.029.072-.019,0,.019,0,.038a.093.093,0,0,1-.01.052.078.078,0,0,1-.072.023c-.019-.006-.023-.033-.023-.038S631.563,952.768,631.563,952.759Zm.331-.209c0-.01.033-.029.052-.029s.029.023.033.029.01,0,.019.014.023.049.014.068a.071.071,0,0,1-.058.029A.515.515,0,0,1,631.894,952.549Z"
                        transform="translate(-623.551 -940.435)"
                        fill="#82764f"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_105"
                        data-name="Path 105"
                        d="M607.86,974.66a.27.27,0,0,1,.1.058.544.544,0,0,1-.049.029.145.145,0,0,0-.052-.087Z"
                        transform="translate(-600.184 -962.292)"
                        fill="#6e6342"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_106"
                        data-name="Path 106"
                        d="M600.312,896.622c-.01-.01.029-.033.052-.029s.033.02.058.023.029-.01.038-.02.043,0,.048,0l.01.014a.054.054,0,0,1,.019-.038.062.062,0,0,1,.052-.01.287.287,0,0,1,.019.072c0,.01-.062.023-.072.014a.69.69,0,0,0,.058.082c.006.01-.043.033-.062.029a.793.793,0,0,1-.223-.136Zm.254-.322a.045.045,0,0,0-.02-.023c-.013,0-.058,0-.058.023a.721.721,0,0,0,.082.221c.048.068.081.124.114.14a.045.045,0,0,0,.058-.019,1.181,1.181,0,0,0,.01-.25,2.3,2.3,0,0,0-.02-.342.052.052,0,0,0-.062.01,1.82,1.82,0,0,0-.1.241h0Z"
                        transform="translate(-592.73 -884.681)"
                        fill="#585136"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_107"
                        data-name="Path 107"
                        d="M591.969,991.947a.157.157,0,0,0-.134-.014c-.062.029-.058.144-.058.144a.092.092,0,0,0,.085-.01.261.261,0,0,0,.107-.12Z"
                        transform="translate(-584.306 -979.334)"
                        fill="#574f35"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_108"
                        data-name="Path 108"
                        d="M613.848,940.239c0-.038-.038-.038-.038-.058a.043.043,0,0,1,.042-.033c.019,0,.038.023.062.038s.058.038.062.068-.038.11-.085.11-.033-.087-.043-.126Zm.375-.052s-.078.023-.072,0,.023-.029.048-.029a.077.077,0,0,1,.049-.023.041.041,0,0,1,.029.01s.052-.023.068-.01,0,.014.014.029a.139.139,0,0,1,.023.058c0,.016-.058.049-.1.043S614.232,940.2,614.223,940.187Zm.452-.087s.023.014,0,.029a.317.317,0,0,1-.14.043c-.058,0-.11.01-.11-.01s.049-.058.078-.068a.062.062,0,0,1,.049-.023c.023,0,.114-.01.14-.014s.043.01.029.029S614.675,940.1,614.675,940.1Zm.134-.6s-.029.062-.062.062-.033-.014-.033-.023.033-.048.029-.058-.033,0-.029-.023.033-.043.062-.038a.128.128,0,0,1,.078-.029c.033,0,.062.01.062.029s-.038.062-.052.072-.035.026-.054.01Zm-.442,1.147s-.038,0-.038.023.01.01.023,0l.023,0s0,.023.033.023a.184.184,0,0,0,.068-.023c.023-.01.043-.019.043-.038a.058.058,0,0,0-.058-.049.079.079,0,0,0-.043.01s-.01-.019-.043,0-.029.02-.019.029.012.026.012.026Zm-.219.2c0-.01.048-.029.062-.023a.249.249,0,0,1,.052.085c0,.01-.048.033-.068.033a.09.09,0,0,1-.052-.038s.023-.01.023-.014-.017-.033-.017-.043Zm-.154-.283c.01,0,.01-.014.023-.023a.033.033,0,0,1,.029,0,.047.047,0,0,1,.033-.023c.023,0,.043,0,.038.01,0,.029.019.048.019.072s-.014.052-.062.072a.341.341,0,0,1-.124.01.064.064,0,0,1-.01-.062.161.161,0,0,1,.053-.05h0Z"
                        transform="translate(-606.058 -927.473)"
                        fill="#82764f"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_109"
                        data-name="Path 109"
                        d="M630.152,1032.31s-.033.019-.033.029a.089.089,0,0,0,0,.029c0,.006.043,0,.049-.01S630.152,1032.32,630.152,1032.31Z"
                        transform="translate(-622.154 -1019.204)"
                        fill="#6e6342"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_110"
                        data-name="Path 110"
                        d="M603.83,1024.4a.418.418,0,0,1,.078.01c.019.01.033.029.014.052s-.038.058-.081.052-.1-.029-.1-.049a.093.093,0,0,1,.023-.068c.019-.016.029-.006.062,0h0Z"
                        transform="translate(-596.12 -1011.382)"
                        fill="#585136"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_111"
                        data-name="Path 111"
                        d="M587.617,1026.7a.548.548,0,0,0-.078.072c-.02.023-.115.143-.144.169a.353.353,0,0,1,.033-.049.2.2,0,0,0-.081.1c-.023.072.13.111.231.14s.14.038.14.038a1.079,1.079,0,0,1-.1-.177c-.038-.091-.058-.1-.033-.144s.049-.072.049-.1S587.617,1026.7,587.617,1026.7Z"
                        transform="translate(-579.931 -1013.666)"
                        fill="#574f35"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_112"
                        data-name="Path 112"
                        d="M435.66,1031.16a.114.114,0,0,0,.043,0,1.979,1.979,0,0,1,.648-.1,3.465,3.465,0,0,1,.7.115c.4.1.893.312,1.213.431.085.033.169.091.23.114a1.462,1.462,0,0,0,.4.12,1.553,1.553,0,0,0,.522-.072c.221-.049.6-.072.931-.12a1.909,1.909,0,0,0,.316-.072,1.666,1.666,0,0,1-.9.359,2.8,2.8,0,0,1-.772.01,2.344,2.344,0,0,1-.437-.078c-.115-.033-.349-.12-.638-.192-.2-.053-.427-.091-.685-.14a8.1,8.1,0,0,1-1.573-.38Z"
                        transform="translate(-430.187 -1017.973)"
                        fill="#252211"
                        fillRule="evenodd"
                    />
                    <line
                        id="Line_1"
                        data-name="Line 1"
                        x1="1.617"
                        y1="1.51"
                        transform="translate(3.527 9.217)"
                        fill="none"
                    />
                    <path
                        id="Path_113"
                        data-name="Path 113"
                        d="M230.229,944.94c-.154.13-.316.254-.475.375l-.479.368c-.163.12-.322.244-.485.365s-.326.235-.5.345c.153-.13.316-.25.479-.369s.332-.234.489-.354l.479-.369c.165-.12.324-.244.491-.361Zm-.848,1.358s.173-.144.388-.345a8.305,8.305,0,0,1,.7-.629l-1.089.974Z"
                        transform="translate(-225.469 -932.952)"
                        fill="#cfb66c"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_114"
                        data-name="Path 114"
                        d="M313.56,975.638c.085-.085.177-.169.268-.25l.14-.12c.043-.038.091-.081.134-.124.085-.085.169-.177.254-.264a1.632,1.632,0,0,1,.134-.124.362.362,0,0,1,.078-.052.226.226,0,0,1,.081-.043c-.019.029-.043.043-.062.068s-.043.043-.062.062c-.043.043-.091.082-.134.12-.091.078-.186.154-.277.235s-.176.169-.268.25-.19.165-.285.243Zm1.16-.776s-.633.619-.763.72Z"
                        transform="translate(-309.648 -962.292)"
                        fill="#cfb66c"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_115"
                        data-name="Path 115"
                        d="M345.423,990.44a2.066,2.066,0,0,1-.183.186l-.192.182c-.062.062-.12.124-.186.186s-.13.115-.2.169l.186-.182c.062-.062.13-.115.2-.177l.186-.182C345.293,990.558,345.355,990.5,345.423,990.44Zm.029.336a4.039,4.039,0,0,1-.206.475c-.163.326-.407.734-.514.941Z"
                        transform="translate(-340.35 -977.87)"
                        fill="#cfb66c"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_116"
                        data-name="Path 116"
                        d="M351.138,1016.69a.544.544,0,0,1-.043.2,1.946,1.946,0,0,1-.078.182c-.029.058-.062.12-.1.177s-.072.114-.1.173l-.2.345c-.068.115-.134.231-.206.342a3.169,3.169,0,0,1,.177-.355c.068-.115.13-.23.192-.349a1.963,1.963,0,0,0,.081-.182c.029-.062.058-.12.081-.177s.052-.12.081-.177a1.139,1.139,0,0,1,.1-.175Z"
                        transform="translate(-346.037 -1003.784)"
                        fill="#cfb66c"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_117"
                        data-name="Path 117"
                        d="M447.129,1141.08a.961.961,0,0,0-.173.576C447.008,1141.487,447.074,1141.229,447.129,1141.08Zm.182.255s-.068.691-.124,1.03A4.161,4.161,0,0,0,447.311,1141.335Zm1.271,1.071a7.31,7.31,0,0,0-.293,1.079c.062-.241.182-.734.293-1.08Z"
                        transform="translate(-441.337 -1126.583)"
                        fill="#dec270"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_118"
                        data-name="Path 118"
                        d="M626.67,1137s.466.768.815,1.424A3.234,3.234,0,0,0,626.67,1137Z"
                        transform="translate(-618.753 -1122.555)"
                        fill="#cbaf59"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_119"
                        data-name="Path 119"
                        d="M724.52,1225.43a14.12,14.12,0,0,1,.691,1.4A2.133,2.133,0,0,0,724.52,1225.43Z"
                        transform="translate(-715.352 -1209.854)"
                        fill="#e3c677"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_120"
                        data-name="Path 120"
                        d="M874.182,987.886c.078-.048.231-.312.365-.378a.917.917,0,0,0,.355-.215.855.855,0,0,1,.417-.336c.369-.159.115-.365.115-.365a1.2,1.2,0,0,1,.13-.111.368.368,0,0,0,.2-.312,1.36,1.36,0,0,0-.274-.85c.206-.043.6-.072.844-.134a1.207,1.207,0,0,0,.413-.173.471.471,0,0,1,.1-.557,3.245,3.245,0,0,0,.638-.759,1.864,1.864,0,0,0-1.17.149.894.894,0,0,1,.111.062,2.193,2.193,0,0,0-.6.254c-.278.235-.312.427-.613.571s-.6.1-.854.221a2.259,2.259,0,0,0-.378.258c.019.023,0,.062.033.1-.023.033-.159.254-.3.254.014.053.13.091.13.091a.627.627,0,0,1-.3.078,2.206,2.206,0,0,0,.5.423c-.023.048-.12.12-.081.212s.153.215.6.316a3.908,3.908,0,0,1-.844.014,1.4,1.4,0,0,0-.633-.014c.023.023.085.023.14.085-.058,0-.423-.043-.547.12a1.059,1.059,0,0,0-.177.633.165.165,0,0,0-.1.212c.033.12.206.159.316.235s.12.11.225.091.274-.134.369-.134a.248.248,0,0,1,.163.072s.258-.124.283-.1,0,.173.029.2a1.866,1.866,0,0,0,.394-.2Z"
                        transform="translate(-861.335 -971.177)"
                        fill="#ecd592"
                        fillRule="evenodd"
                    />
                    <path
                        id="Path_121"
                        data-name="Path 121"
                        d="M468,420.432a6.105,6.105,0,0,0-4.211-3.712H455.24l.033,3.19h1.7v7.124H455.24v3.184h8.317c2,0,3.611-2.014,3.611-2.014a8.608,8.608,0,0,0,.836-7.772Zm-4.4,5.625s-.652.941-1.362.941h-1.42l-.034-7.081h1.822s.844.177,1.434,1.847A5.57,5.57,0,0,1,463.6,426.058Z"
                        transform="translate(-449.516 -411.489)"
                        fill="rgba(255,255,255,0.8)"
                        fillRule="evenodd"
                    />
                </g>
            </g>
        </g>
    </svg>
);
export default dogeIcon;
